import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { TabFilter } from '@model/filter/tab-filter.interface';

@Component({
    selector: 'app-filter',
    templateUrl: 'filter.component.html',
    styleUrls: ['filter.component.scss'],
})
export class FilterComponent implements OnInit, OnChanges {
    @Input() elements: TabFilter[];
    @Input() defaultSelected?;
    @Input() allowInitTrigger?: boolean = false;
    @Input() isCircle?: boolean = false;
    /**
     * Tells whether the filter tab is displayed without any highlighted option.
     */
    @Input() isNoOptionSelected?: boolean = false;
    /**
     * If the value is set, then the provided tab filter will be forcefully selected on the component.
     */
    @Input() externalSelection?: TabFilter;
    @Output() onChange: EventEmitter<TabFilter> = new EventEmitter();
    selectedValue?: TabFilter;

    ngOnInit() {
        this.selectedValue = this.defaultSelected ? this.defaultSelected : this.elements[0];
        if (this.allowInitTrigger) {
            this.onSelect(this.selectedValue);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['externalSelection']) {
            const currentValue = changes['externalSelection'].currentValue;

            if (!currentValue) {
                return;
            }

            this.selectedValue = currentValue;
        }
    }

    onSelect(value: TabFilter) {
        this.selectedValue = value;
        this.onChange.emit(value);
    }
}
